export default [
  'OneColumnStoreLocatorPage'
]

/*
Appears on:
/store-locator
*/
